import React from 'react';

export default function SendReceiptsModal({ 
    show, 
    onClose, 
    onSend, 
    isSending,
    isCalculating,
    receiptTargetGroup, 
    setReceiptTargetGroup,
    receiptMonth,
    setReceiptMonth,
    receiptYear,
    setReceiptYear,
    receiptCount,
    propertyDetails
}) {
    if (!show) return null;
    
    const apartmentName = propertyDetails?.results?.[0]?.name || "Apartment Name";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
                <h2 className="text-xl font-semibold mb-4 text-blue-600 border-b pb-2">Send SMS Receipts</h2>
                
                <div className="mb-4 mt-2">
                    <label className="block text-gray-700 font-bold mb-2">Send receipts to:</label>
                    <select 
                        value={receiptTargetGroup} 
                        onChange={(e) => setReceiptTargetGroup(e.target.value)}
                        className="w-full border rounded px-3 py-2 text-gray-700 bg-white focus:outline-none focus:border-blue-500"
                    >
                        <option value="all">All Tenants who made payments</option>
                        <option value="fully_paid">Only Fully Paid Tenants</option>
                        <option value="partially_paid">Only Partially Paid Tenants</option>
                    </select>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="block text-gray-700 font-bold mb-2">Month:</label>
                        <select 
                            value={receiptMonth} 
                            onChange={(e) => setReceiptMonth(e.target.value)}
                            className="w-full border rounded px-3 py-2 text-gray-700 bg-white focus:outline-none focus:border-blue-500"
                        >
                            <option value="january">January</option>
                            <option value="february">February</option>
                            <option value="march">March</option>
                            <option value="april">April</option>
                            <option value="may">May</option>
                            <option value="june">June</option>
                            <option value="july">July</option>
                            <option value="august">August</option>
                            <option value="september">September</option>
                            <option value="october">October</option>
                            <option value="november">November</option>
                            <option value="december">December</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-gray-700 font-bold mb-2">Year:</label>
                        <select 
                            value={receiptYear} 
                            onChange={(e) => setReceiptYear(e.target.value)}
                            className="w-full border rounded px-3 py-2 text-gray-700 bg-white focus:outline-none focus:border-blue-500"
                        >
                            {[2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].map(y => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                </div>
                
                <div className="mb-4 p-3 bg-gray-50 border rounded text-sm text-gray-600">
                    <p className="font-bold text-gray-800 mb-1">Message Preview:</p>
                    <p className="mb-0">
                        Hello [Tenant Name],<br />
                        Here is your receipt for House: [House Number]-{apartmentName}, Period: [Month],[Year]. Click on the link below to download your receipt.<br />
                        https://kodinyumba.app/... [Kodi Powered by Jumuisha Ltd]
                    </p>
                </div>
                
                <p className="font-bold text-center text-gray-800 my-4">
                    {isCalculating ? 'Calculating tenants...' : `Send receipts to (${receiptCount}) tenants`}
                </p>

                <div className="flex justify-end space-x-2 border-t pt-4">
                    <button 
                        onClick={onClose} 
                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded transition-colors"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={onSend} 
                        disabled={receiptCount === 0 || isSending || isCalculating}
                        className={`px-4 py-2 rounded text-white transition-colors ${receiptCount === 0 || isSending || isCalculating ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'}`}
                    >
                        {isSending ? 'Sending...' : 'Send Receipts'}
                    </button>
                </div>
                
                <button
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl leading-none"
                    onClick={onClose}
                >
                    &times;
                </button>
            </div>
        </div>
    );
}
